import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import { paths } from "api/schema/api-schema";
import assert from "assert";

export const workflowTableRowList = djangoClientQueryFactory(
  { method: "get", path: "/library/workflow_table_row/" },
  {
    formatInput: (
      params: paths["/library/workflow_table_row/"]["get"]["parameters"],
    ) => {
      return { params };
    },

    formatQueryKey: (p) => {
      const key = [];
      if (p.query?.id__in) {
        key.push(...p.query.id__in);
      }
      return key;
    },

    handleResponse: (res) => {
      const created = res.data;

      assert(
        created !== undefined,
        "Expected data to be defined when creating rows",
      );
      return created;
    },
  },
);
